var map = {
	"./anhui.json": "736c",
	"./aomen.json": "7a6a",
	"./beijing.json": "3ecb",
	"./china.json": "f3f6",
	"./chongqing.json": "b4f6",
	"./fujian.json": "16aa",
	"./gansu.json": "1afd",
	"./guangdong.json": "266b",
	"./guangxi.json": "13d53",
	"./guizhou.json": "7127",
	"./hainan.json": "9644",
	"./hebei.json": "01eb",
	"./heilongjiang.json": "01dd",
	"./henan.json": "cf8c",
	"./hubei.json": "de11",
	"./hunan.json": "a435",
	"./jiangsu.json": "d7aa",
	"./jiangxi.json": "e1a1",
	"./jilin.json": "0c31",
	"./liaoning.json": "0e25",
	"./neimenggu.json": "b2fc",
	"./ningxia.json": "d9ab",
	"./qinghai.json": "f2ee",
	"./shaanxi.json": "b9cf",
	"./shandong.json": "2f08",
	"./shanghai.json": "8481",
	"./shanxi.json": "732c",
	"./sichuan.json": "1a1b",
	"./taiwan.json": "34f0",
	"./tianjin.json": "63df",
	"./xianggang.json": "19bb",
	"./xinjiang.json": "38ae",
	"./xizang.json": "acd5",
	"./yunnan.json": "0c45",
	"./zhejiang.json": "560c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88c5";